import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.QIS_SERVER_PREFIX}/farmers-digital-prescription`;
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    getByUserId: () => `${RESOURCE_ENDPOINT}/getByUserId`,
    checkIsDuplicateFarmerId: (farmerId: any) => `${RESOURCE_ENDPOINT}/check-is-duplicate-farmer-id/${farmerId}`,
    getByUUId: (uuid: any) => `${RESOURCE_ENDPOINT}/share-digital-prescription/${uuid}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    askGemini: () => `${RESOURCE_ENDPOINT}/ask-gemini`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
};

export default class PesticideApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();

        return HttpService.get(url, params, headers);
    };

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    };

    public getByUserId = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getByUserId();
        return HttpService.get(url, params, headers);
    };

    public checkIsDuplicateFarmerId = (farmerId: any): AxiosPromise<any> => {
        const url = endpoints.checkIsDuplicateFarmerId(farmerId);
        return HttpService.get(url);
    };

    public getByUUId = (uuid: any): AxiosPromise<any> => {
        const url = endpoints.getByUUId(uuid);
        return HttpService.get(url);
    };

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    };

    public askGemini = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.askGemini();
        return HttpService.post(url, payload, params, headers);
    };

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    };

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    };

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    };

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    };

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    };
}
